<template>
    <div class="row" style="margin-top:30px">
        <div class="col-3" style="height: 140px;"  v-if="hasFunzionalita(2)">
            <div class="card shadow lift-panel bg-secondary " v-on:click="openModulo('TipologiaPratica')" style="margin-top:20px;">
                <div class="card-body" >
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h4" style="color:#fff">Tipologia Pratica</div>  
                            <div class="h6 mb-0  " style="color:#fff" >Visualizza e gestisci le persone fisiche</div> 
                        </div>
                        <div class="col-auto">
                            <i class="fas fa-file-contract fa-4x"  style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>        
        </div>

        <div class="col-3" style="height: 140px;"  v-if="hasFunzionalita(2)">
            <div class="card shadow lift-panel bg-secondary " v-on:click="openModulo('Utenti')" style="margin-top:20px;">
                <div class="card-body" >
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h4" style="color:#fff">Utenti sistema</div>  
                            <div class="h6 mb-0  " style="color:#fff" >Visualizza e gestisci gli utenti del gestionale</div> 
                        </div>
                        <div class="col-auto">
                            <i class="fad fa-users-cog fa-4x"  style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>        
        </div>
        <!-- <div class="col-3" style="height: 140px;"  v-if="hasFunzionalita(2)">
            <div class="card shadow lift-panel bg-secondary " v-on:click="openModulo('PersoneGiuridiche')" style="margin-top:20px;">
                <div class="card-body" >
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h4" style="color:#fff">Stati Pratica</div>  
                            <div class="h6 mb-0  " style="color:#fff" >Visualizza e gestisci le persone giuridiche</div> 
                        </div>
                        <div class="col-auto">
                            <i class="fas fa-info-circle fa-4x"  style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>        
        </div> -->
    </div>
<!--
    <input type="text" class="form-control" v-model="tabella"><button class="btn btn-info" v-on:click="creaTabella()">Crea tabella</button>
-->
</template>
<script>


export default {
    name:"DashAmm",
    components: {
      
    },
    data:function(){
      return{
        utente:{},
        tabella:"",
        dataUltimoOrdine:"",
        filters:global.filters
      }
    },
    methods:{
        creaTabella:function(){
            utils.ajax('nic/generaclasse',{tabella:this.tabella}, (response) => {
            
            });
        },
        openModulo : function(modulo){
            global.router.push(modulo);
        },
        hasFunzionalita : function(id){
            for (var i = 0 ; i < this.$root.utente.funzionalita.length ; i++){
                if (this.$root.utente.funzionalita[i].ID_FUNZIONALITA == id){
                    return true;
                }
            }
            return false;
        }
    },
    computed:{
        
    },
    created: function () {
        /*
        global.utils.ajax('core/home',{}, (response) => {
            this.dataUltimoOrdine = response.data.DATA_ULTIMO_ORDINE;
            this.$root.arrayStati = response.data.NAZIONI;
        });*/
        
        
    },
}
</script>